export default __webpack_public_path__ + "static/media/polygon-delete-active.8c77fdec.svg";